import React from "react";
import { useSelector } from "react-redux";
import classnames from "classnames";

export default () => {
  const currentActivity = useSelector((state) => state.activity);
  const { managerContact } = currentActivity.websiteData.config.data
    ? currentActivity.websiteData.config.data
    : {};
  const { phone, fullName, email } = managerContact ? managerContact : {};
  return (
    (phone || fullName || email) && (
      <div id="contact" className="gradiant-background pwg-section section">
        <div className="container-fluid no-padding">
          <div className="row-4 contact-panel">
            <div
              className="col-md-6"
              style={{
                justifyContent: "center",
                alignItems: "center",
                display: "flex",
              }}
            >
              <div className="single-contact">
                <span
                  className="fa fa-user"
                  style={{
                    color: "white",
                  }}
                />
                <span className="scontact-info heading-light">
                  {fullName ? fullName : "complete manager name"}
                </span>
              </div>
            </div>
            <div
              className="col-md-6"
              style={{
                justifyContent: "center",
                alignItems: "center",
                display: "flex",
              }}
            >
              <div className="single-contact">
                <span
                  className="fa fa-phone"
                  style={{
                    color: "white",
                  }}
                />
                <span className="scontact-info heading-light">
                  {phone ? phone : "complete manager phone"}
                </span>
              </div>
            </div>
            <div
              className="col-md-6"
              style={{
                justifyContent: "center",
                alignItems: "center",
                display: "flex",
              }}
            >
              <div className="single-contact">
                <span
                  className="fa fa-envelope-o"
                  style={{
                    color: "white",
                  }}
                />
                <span className="scontact-info heading-light">
                  {email ? email : "complete manager email"}
                </span>
              </div>
            </div>
            {false && (
              <div className="col-md-6 pl-9">
                <div className="mapouter ">
                  <div className="gmap_canvas">
                    <iframe
                      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3309.3600695690266!2d-6.871735385656144!3d33.95758358063169!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xda7132db6148e4f%3A0xc58f5be4725c7d14!2s%22Les%20Patios%22%20Espace%20Clients%20RCAR!5e0!3m2!1sen!2sma!4v1574935927513!5m2!1sen!2sma"
                      width="600"
                      height="450"
                      frameBorder="0"
                      style={{ border: 0 }}
                      allowFullScreen=""
                    ></iframe>
                  </div>
                </div>
              </div>
            )}
            {false && (
              <div className="col-md-5">
                <div className="single-contact">
                  <span
                    className="fa fa-map-marker"
                    style={{
                      color: "white",
                    }}
                  />
                  <span
                    className="scontact-info"
                    style={{
                      color: "white",
                    }}
                  >
                    Rabat
                  </span>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    )
  );
};
